import * as React from 'react';
import './index.css';
import ContentSuperItem, { ContentSpecType } from '../itemSuperCard/itemSuperCard';
import { RichContentUtils } from './utils';

/*
  Tip:

  layout row : [图片icon && 富文本] && 分隔符
*/

export class CustomRichTextItemView extends ContentSuperItem {
  // private generateSeperatorTags() {
  //   const placeholder = {
  //     type: 'placeholder',
  //     width: 3
  //   };

  //   const seperatorTags = [
  //     placeholder,
  //     {
  //       type: 'text',
  //       fontSize: 10,
  //       fontFamily: Mach.env.isIOS ? 'KeeTa-Bold' : 'KeeTa-Regular',
  //       text: '·',
  //       color: '#C2C2C2',
  //       fontWeight: Mach.env.isIOS ? 400 : 800,
  //       lineHeight: 10,
  //       height: 10
  //     },
  //     placeholder,
  //   ];
  //   return seperatorTags;
  // }

  // 分隔符dot 圆点
  private hasDotDom() {
    return this.props?.hasLastItem;
  }

  render() {
    const content = RichContentUtils.getTextContent(this.props);
    const isEmpty = Object.keys(content).length === 0;
    const inputMaxLines = this.props.style?.maxLines || 1;
    const spec = this.props.specStyle?.spec || 3;
    const dotStyle = this.props.specStyle?.specType || ContentSpecType.Point;
    const flexShrink = this.props.style?.flexShrink !== undefined ? this.props.style?.flexShrink : (this.props?.hasLastItem === false ? 1 : 0);
    const warpStyle = { flexShrink, flexGrow: this.props.style?.flexGrow || 0 };

    return (
      !isEmpty ? (
        <view className="rich-item-container" style={warpStyle}>
          <view style={{ ...content?.style?.warpStyle, alignItems: 'center' }}>
            {/* icon */}
            {content?.icon && <image className="rich-item-icon" src={content.icon} style={{ ...content?.style?.imageStyle }} />}

            {/* content text */}
            {content?.attContents?.length && <rich-text className="rich-item-text" style={{ ...content?.style?.textStyle, maxLines: inputMaxLines }} content={content.attContents} />}
          </view>

          {/* dot */}
          {this.hasDotDom() && dotStyle === ContentSpecType.BlankSpace && (
            <view
              className="rich-item-dot-item" style={{
                backgroundColor: 'transparent', marginLeft: 0, marginRight: 0, width: spec
              }}
            />
          )}
          {this.hasDotDom() && dotStyle === ContentSpecType.Point && (
            <view className="rich-item-dot-item" style={{ marginLeft: spec, marginRight: spec }} />
          )}
          {this.hasDotDom() && dotStyle === ContentSpecType.Line && (
            <view className="rich-item-dot-line" style={{ marginLeft: spec, marginRight: spec }} />
          )}
        </view>
      ) : null
    );
  }
}
